import { render } from "./task-comp.vue?vue&type=template&id=113f3cea&scoped=true"
import script from "./task-comp.vue?vue&type=script&lang=js"
export * from "./task-comp.vue?vue&type=script&lang=js"

import "./task-comp.vue?vue&type=style&index=0&id=113f3cea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-113f3cea"]])

export default __exports__